import { Visibility, VisibilityOff } from '@mui/icons-material';
import { IconButton, InputAdornment, TextField, TextFieldProps } from '@mui/material';
import { FC, useState } from 'react';

export const MaskedInput: FC<TextFieldProps> = (props) => {
  const [showText, setShowText] = useState(false);
  const toggleShowText = () => {
    setShowText(!showText);
  };
  return (
    <TextField
      {...props}
      type={showText ? 'text' : 'password'}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton onClick={toggleShowText}>
              {showText ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};
